import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../ApiClient";
export const getGreeterCust=createAsyncThunk(
    'greeter/getcustomertofetch',
    async({dbName,SearchText},{dispatch,rejectWithValue})=>{
        try{
            const response =await apiClient.get(`WGDealer/GetGreeterCustomer?databaseName=${dbName}&searchText=${SearchText}`)
         return response.data;
        }catch(error){
            return rejectWithValue(error.response?.data||'Error Fetching Data')
        }
    }
)
export const GetSalesPerson=createAsyncThunk(
    'greeter/GetSalesPerson',
    async({databaseName},{dispatch,rejectWithValue})=>{
        try{
            const response =await apiClient.get(`CustomerCreation/GetSalesPersons?databaseName=${databaseName}`)
         return response.data;
        }catch(error){
            return rejectWithValue(error.response?.data||'Error Fetching Data')
        }
    }
)
export const GetGreeterSection=createAsyncThunk(
    'greeter/GetGreeterSection',
    async(_,{dispatch,rejectWithValue})=>{
        try{
            const response =await apiClient.get(`WGDealer/GetGreeterSection`)
         return response.data;
        }catch(error){
            return rejectWithValue(error.response?.data||'Error Fetching Data')
        }
    }
)
export const GreeterPostDetails=createAsyncThunk(
    'greeter/PostGreeter',
    async(postData,{dispatch,rejectWithValue})=>{
        try{
            const response =await apiClient.post(`WGDealer/InsertGreeterPostDetails`,postData)
         return response.data;
        }catch(error){
            return rejectWithValue(error.response?.data||'Error Fetching Data')
        }
    }
)
export const GetGuestCode=createAsyncThunk(
    'greeter/GetGuestCode',
    async({slpCode},{dispatch,rejectWithValue})=>{
        try{
            const response =await apiClient.get(`WGDealer/GetGuestCode?SlpCode=${slpCode}`,)
         return response.data;
        }catch(error){
            return rejectWithValue(error.response?.data||'Error Fetching Data')
        }
    }
)